import { Input, InputProps } from '@design/components/input/Input';
import clsx from 'clsx';
import { ChangeEventHandler, RefObject } from 'react';

import styles from './BaseRenameInput.module.scss';

interface BaseRenameInputProps extends InputProps {
  className?: string;
  value: string;
  ref?: RefObject<HTMLInputElement | null> | null;
  onChange: ChangeEventHandler<HTMLInputElement>;
  showLengthIndicator?: boolean;
}

export const BaseRenameInput = ({
  className,
  value,
  onChange,
  showLengthIndicator = true,
  maxLength = 30,
  ref = null,
  ...rest
}: BaseRenameInputProps) => {
  return (
    <Input
      className={clsx(styles.styledInput, className)}
      ref={ref}
      data-testid="base-rename-input"
      value={value}
      onChange={onChange}
      maxLength={maxLength}
      rightIcon={
        showLengthIndicator ? `${value.length}/${maxLength}` : undefined
      }
      {...rest}
    />
  );
};
